/**
 * Team Reviews access allowlist.
 *
 * Per Jake (Feb 2026): "I want a list of all of our employees ... only
 * accessible and viewable by admins, so only Jake Majeski and Brady
 * Rayburn."
 *
 * Backend `routes/team_reviews.py::TEAM_REVIEWS_ADMINS` mirrors this
 * list (server-side defense in depth). Both must match — if you add or
 * remove a name here, do the same on the backend.
 *
 * NOTE: Brady's record on `db.users` is "Brady Raburn" (no 'y') —
 * accept both spellings until that name typo gets fixed upstream.
 */
const TEAM_REVIEWS_ALLOWED_NAMES = [
  "jake majeski",
  "brady raburn",
  "brady rayburn",
];

export function canAccessTeamReviews(user) {
  if (!user || !user.name) return false;
  return TEAM_REVIEWS_ALLOWED_NAMES.includes(String(user.name).trim().toLowerCase());
}

export const JAKE_FULL_NAME_LC = "jake majeski";

export function isJake(user) {
  if (!user || !user.name) return false;
  return String(user.name).trim().toLowerCase() === JAKE_FULL_NAME_LC;
}
